export const removeProtocol = function() {
  return function(input) {
    if (!input) return;
    return input.replace(/https?\:\/\//,'');
  };
};
